function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.80175 5.64586C2.956 5.1303 3.43704 4.75009 4 4.75009H20C20.5629 4.75009 21.0439 5.1302 21.1982 5.64566L11.9998 12.0845L2.80175 5.64586ZM1.25 6.01851V18.0001C1.25 19.5143 2.48579 20.7501 4 20.7501H11C11.4142 20.7501 11.75 20.4143 11.75 20.0001C11.75 19.5859 11.4142 19.2501 11 19.2501H4C3.31421 19.2501 2.75 18.6859 2.75 18.0001V7.44062L11.5697 13.6144C11.828 13.7952 12.1717 13.7952 12.4299 13.6144L21.25 7.44037V12.0001C21.25 12.4143 21.5858 12.7501 22 12.7501C22.4142 12.7501 22.75 12.4143 22.75 12.0001V6.00009C22.75 4.48588 21.5142 3.25009 20 3.25009H4C2.49361 3.25009 1.26278 4.47314 1.2501 5.97664C1.24968 5.99061 1.24964 6.00457 1.25 6.01851Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9997 15.5833C17.1127 15.5833 15.583 17.1129 15.583 18.9999C15.583 20.8869 17.1127 22.4166 18.9997 22.4166C20.8866 22.4166 22.4163 20.8869 22.4163 18.9999C22.4163 17.1129 20.8866 15.5833 18.9997 15.5833ZM14.083 18.9999C14.083 16.2845 16.2843 14.0833 18.9997 14.0833C21.7151 14.0833 23.9163 16.2845 23.9163 18.9999C23.9163 21.7153 21.7151 23.9166 18.9997 23.9166C16.2843 23.9166 14.083 21.7153 14.083 18.9999Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5828 18.9998C16.5828 18.5856 16.9186 18.2498 17.3328 18.2498H20.6661C21.0803 18.2498 21.4161 18.5856 21.4161 18.9998C21.4161 19.414 21.0803 19.7498 20.6661 19.7498H17.3328C16.9186 19.7498 16.5828 19.414 16.5828 18.9998Z",
  fill: "currentColor"
});

function SvgUnsubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscription);
export default __webpack_public_path__ + "static/media/unsubscription.703ace98.svg";
export { ForwardRef as ReactComponent };